const NAMESPACE = "pvsystem";

const KEYS = {
    addInverterButtonText: "addInverterButtonText",
    zipCodeNotConfiguredBlockCalculationText: "zipCodeNotConfiguredBlockCalculationText",
    needsRecalculatedMessage: "needsRecalculatedMessage",
    notYetCalculatedMessage: "notCalculatedMessage",
    calculateButtonText: "calculateButtonText",
    monthlyEstimatedProductionLabel: "monthlyEstimatedProductionLabel",
    systemRatingLabel: "systemRatingLabel",
    csiRatingLabel: "csiRatingLabel",
    inverterRatingLabel: "inverterRatingLabel",
    estimatedAnnualProductionLabel: "estimatedAnnualProductionLabel",
    designFactorLabel: "designFactorLabel",
    averageInverterEfficiencyLabel: "averageInverterEfficiencyLabel",
    ptcModuleRatingLabel: "ptcModuleRatingLabel",
    invalidZipCodeErrorMessage: "invalidZipCodeErrorMessage",
    invalidLocationErrorMessage: "invalidLocationErrorMessage",
    totalNameplateEnergyCapacityLabel: "totalNameplateEnergyCapacityLabel"
};

const MESSAGES = {
    [KEYS.addInverterButtonText]: {
        value: "Add Inverter",
        comment: "Label for button which creates a new inverter"
    },
    [KEYS.zipCodeNotConfiguredBlockCalculationText]: {
        value: "Zip Code has not been configured for form; calculation not enabled.",
        comment: "Error message for when no zip code was configured for calculation for this element"
    },
    [KEYS.needsRecalculatedMessage]: {
        value: "Needs to be recalculated",
        comment: "Message for communicating that the output values need to be recalculated in light of new input"
    },
    [KEYS.notYetCalculatedMessage]: {
        value: "Not yet calculated",
        comment: "Message for communicating that the output data has not yet been calculated"
    },
    [KEYS.calculateButtonText]: {
        value: "Calculate",
        comment: "Label for button which runs calculations"
    },
    [KEYS.monthlyEstimatedProductionLabel]: {
        value: "Monthly Estimated Production (kWh):",
        comment: "Label for outputted data of monthly estimated production"
    },
    [KEYS.systemRatingLabel]: {
        value: "System Rating:",
        comment: "Label for calculated rating of pv system"
    },
    [KEYS.csiRatingLabel]: {
        value: "CSI Rating:",
        comment: "Label for calculated CSI rating of pv system"
    },
    [KEYS.inverterRatingLabel]: {
        value: "Inverter Rating:",
        comment: "Label for calculated inverter rating of pv system"
    },
    [KEYS.estimatedAnnualProductionLabel]: {
        value: "Estimated Annual Production:",
        comment: "Label for calculated annual production estimate"
    },
    [KEYS.designFactorLabel]: {
        value: "Design Factor:",
        comment: "Label for calculated design factor"
    },
    [KEYS.averageInverterEfficiencyLabel]: {
        value: "Average Inverter Efficiency:",
        comment: "Label for calculated average efficiency for the inverter"
    },
    [KEYS.ptcModuleRatingLabel]: {
        value: "PTC Module Rating:",
        comment: "Label for calculated PTC module rating"
    },
    [KEYS.invalidZipCodeErrorMessage]: {
        value: "Please specify a valid zip code for '{zipFieldDescriptor}'.",
        comment: "Error message when a valid zip code has not been specified"
    },
    [KEYS.invalidLocationErrorMessage]: {
        value: "Please specify a valid location for '{locationFieldDescriptor}'.",
        comment:
            "Error message when an invalid location is specified and the user tries to use the location for output estimation."
    },
    [KEYS.totalNameplateEnergyCapacityLabel]: {
        value: "Total Nameplate Energy Capacity (Storage)",
        comment: "Label for energy calculation result"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
